<script>
	import { getContext } from "svelte";

	import DeleteDraft from "./DeleteDraft.svelte";

	export let draft;

	$: draftId = draft.id;

	const draftSelected = getContext("draftSelected");
	const closeMenusUnlessFullSideMargins = getContext(
		"closeMenusUnlessFullSideMargins"
	);

	function selectDraft() {
		closeMenusUnlessFullSideMargins();
		draftSelected(draft.id);
	}
</script>

<div
	class="bg-base-300 hover:bg-primary-content hover:text-primary py-2 px-4 rounded-lg flex gap-2 cursor-pointer"
>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		class="grow overflow-hidden"
		style="text-overflow: ellipsis; white-space: nowrap;"
		on:click={selectDraft}
	>
		{draft.text}
	</div>
	<DeleteDraft {draftId} />
</div>
